import { createFileRoute } from '@tanstack/react-router'
import { SourcesPage } from '@/features/sources'

interface Search {
  q?: string
}

/** C-11 Sources (saved immediately, outside the draft); `q` in the URL (Frontend §6.1). */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/sources')({
  validateSearch: (raw: Record<string, unknown>): Search =>
    typeof raw.q === 'string' && raw.q !== '' ? { q: raw.q.slice(0, 100) } : {},
  component: function SourcesRoute() {
    const { clinicId } = Route.useParams()
    const { q } = Route.useSearch()
    const navigate = Route.useNavigate()
    return (
      <SourcesPage
        clinicId={clinicId}
        q={q ?? ''}
        onSearch={(next) => {
          void navigate({ search: next ? { q: next } : {}, replace: true })
        }}
      />
    )
  },
})
